// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment, createContext, useContext, useEffect, useMemo,
    useState} from 'react';
import {useLocation} from 'react-router-dom';
// @ts-ignore
import cookie from 'cookie';
import {Data_context} from './data_ctx';
// @ts-ignore
import {get, set} from '/util/storage.js';
import {Modal, i_modal_props_base} from './lib/modal';
import cn from 'classnames';
import {perr} from 'hola_pub_util';
import {use_rebranded} from './ui/use_rebranded';
import {Popup, i_popup_props_base} from './ui/popup';

export type t_theme_name = 'default' | 'toolip' | 'hola2023'
    | 'brand' | 'dark' | 'purple' | 'oculus' | 'browserai';
interface i_theme {
    root: string;
    bold: string;
    logo_grey: string;
    grey_2: string;
    grey_3: string;
    light: string;
    dark: string;
    p1: string;
    p2: string;
    p3: string;
    p4: string;
    p5: string;
    xs: string;
    tiny: string;
    container: string;
    block: string;
    primary: string;
    bg: string;
    bottom_bg: string;
    H1: string;
    H2: string;
    H3: string;
    H4: string;
    H5: string;
    H6: string;
    P: string;
    u1: string;
    u2: string;
    u3: string;
    u4: string;
    u5: string;
    mono18: string;
    mono16: string;
    mono14: string;
    p12: string;
    p14: string;
    p16: string;
    p18: string;
    p20: string;
    p22: string;
    p24: string;
    reg: string;
    med: string;
    color_n300: string;
    color_n400: string;
    color_n500: string;
    color_n600: string;
    color_n700: string;
    color_n800: string;
    color_n900: string;
    color_n1000: string;
    color_n1100: string;
    [propname:string]: string;
}

const default_theme = ()=>({});
const default_theme_name = ()=>'hola2023' as t_theme_name;

// XXX dmitriiz: hola_theme by default
export const Settings_context = createContext({
    theme: default_theme() as i_theme,
    theme_name: default_theme_name(),
    change: (th_name:string)=>{
        console.error('try to change theme before initial ' + th_name);
    },
    app_settings: null as any,
    set_app_settings: null as any,
    show_modal: (id: string, Component:any, props: i_modal_props_base)=>{
        console.error('trying to show modal before initialization: ', id,
            Component, props);
    },
    show_popup: (id: string, Component:any, props: i_popup_props_base)=>{
        console.error('trying to open popup before initialization: ', id,
          Component, props);
    },
    close_popup: (id: string)=>{
        console.error('trying to close popup before initialization: ', id);
    },
    popups: [] as any[],
    themes_add: {} as any,
});

export const Modal_singleton = {
    show_modal: (id: string, Component:any, props: i_modal_props_base)=>{
        console.error('trying to show modal before initialization: ', id,
            Component, props);
    },
};

const r_or_call = v=>{
    if (typeof v=='function')
        return v();
    return v;
};

export const Settings_provider = ({children, route, location,
        app_settings, set_app_settings, is_portal, themes_add,
        app_default_theme}:any)=>{
    const {pathname} = location || useLocation();
    const {refresh_by_loaded} = useContext(Data_context);
    const [refresh, set_refresh] = useState(0);
    const is_dark_cookie = cookie.get('theme')=='dark' || get('theme')=='dark';
    const is_brand_cookie = cookie.get('theme')=='brand'
        || get('theme')=='brand';
    const is_hola2023_cookie = cookie.get('theme')=='hola2023'
        || get('theme')=='hola2023';
    const is_purple_cookie = cookie.get('theme')=='purple'
        || get('theme')=='purple';
    const prev_state = useMemo(()=>({
        prev_theme_name: default_theme_name(),
    }), []);
    let route_default_theme = route && route.loaded ?
        r_or_call(route.default_theme) : '';
    if (!route_default_theme)
        route_default_theme = app_default_theme;
    let is_dark_available = route && is_dark_cookie
        && (route.loaded ? route.is_dark_available :
                prev_state.prev_theme_name=='dark')
        || route_default_theme == 'dark';
    const is_brand_theme = route_default_theme == 'brand' || is_brand_cookie;
    const is_hola2023_theme = route_default_theme == 'hola2023'
        || is_hola2023_cookie;
    const is_toolip = route_default_theme == 'toolip' || is_hola2023_cookie;
    const is_oculus = route_default_theme == 'oculus' || is_hola2023_cookie;
    const is_bb = route_default_theme == 'browserai' || is_hola2023_cookie;
    const is_purple_theme = route_default_theme == 'purple'
        || is_purple_cookie;
    const is_rebranded = use_rebranded({location, is_portal});
    const [modals, set_modals] = useState<{[propname:string]: any}>({all: []});
    const [popups_state, set_popups] =
        useState<{[propname:string]: any}>({all: []});
    const popups = useMemo(()=>[], []);
    const state = useMemo(()=>{
        const theme_conf = is_toolip ?
            {theme: themes_add.toolip_theme as i_theme, name: 'toolip'}
            : is_oculus ?
            {theme: themes_add.oculus_theme as i_theme, name: 'oculus'}
            : is_bb ?
            {theme: themes_add.browserai_theme as i_theme,
                name: 'browserai'}
            : is_hola2023_theme || is_rebranded ?
            {theme: themes_add.hola2023 as i_theme, name: 'hola2023'}
            : is_brand_theme ?
            {theme: themes_add.brand as i_theme, name: 'brand'}
            : is_purple_theme ?
            {theme: themes_add.purple as i_theme, name: 'purple'}
            : is_dark_available ?
            {theme: themes_add.dark as i_theme, name: 'dark'}
            : {theme: themes_add.default as i_theme,
                name: default_theme_name()};
        const show_modal = (id:string, cmp:any, props: i_modal_props_base)=>{
            perr({id: `www_hola_modal_${id}_show`});
            set_modals(old=>{
                if (old[id])
                    return {...old, [id]: {...old[id], opened: true}};
                return {...old, [id]: {cmp, props, opened: false},
                    all: [...old.all, id]};
            });
            setTimeout(()=>{
                set_modals(old=>({...old, [id]: {...old[id], opened: true}}));
            }, 0);
        };
        Modal_singleton.show_modal = show_modal;
        // @ts-ignore
        window.last_global_theme_selected = theme_conf.name;
        const show_popup = (id:string, cmp:any, props: i_popup_props_base)=>{
            set_popups(old=>{
                const all = [...old.all, id];
                return {...old,
                    [id]: {cmp, props, visible: true},
                    all: all.filter((m_id, i)=>i==all.indexOf(m_id)),
                };
            });
        };
        const close_popup = (id:string)=>{
            set_popups(old=>{
                const {[id]: current, ...rest} = old;
                if (!current)
                    return old;
                if (current.props.on_close)
                    current.props.on_close();
                return {...rest, [id]: {...current, visible: false}};
            });
        };
        return {
            theme: theme_conf.theme,
            theme_name: theme_conf.name as t_theme_name,
            change: (th_name:string)=>{
                const valid_name = ['brand', 'purple', 'dark', 'hola2023'
                    ].indexOf(th_name) >= 0 ? th_name
                    : default_theme_name();
                cookie.set('theme', valid_name);
                set('theme', valid_name);
                set_refresh(refresh + 1);
            },
            popups,
            app_settings,
            set_app_settings,
            show_modal,
            show_popup,
            close_popup,
            themes_add,
        };
    }, [pathname, refresh, refresh_by_loaded, app_settings, is_rebranded,
        route && route.loaded]);
    useEffect(()=>{
        if (!get('rebranded_visited'))
            set('rebranded_visited', 1);
    }, [state.theme_name]);
    const unmutable_state = useMemo(()=>({
        focused_element: null,
    }), []);
    useEffect(()=>{
        const global_blur = ev=>{
            const newel = ev.relatedTarget;
            unmutable_state.focused_element = newel;
            popups_state.all.forEach(popup_id=>{
                const popup = popups_state[popup_id];
                if (popup.visible)
                {
                    if (popup.props.parent.contains(newel))
                        return;
                    if (popup.props.parent==newel)
                        return;
                    const popup_el = document.getElementById(popup_id);
                    if (popup_el.contains(newel))
                        return;
                    if (popup_el==newel)
                        return;
                    state.close_popup(popup_id);
                }
            });
        };
        window.addEventListener('blur', global_blur, {capture: true});
        return ()=>{
            window.removeEventListener('blur', global_blur);
        };
    }, [popups_state]);
    prev_state.prev_theme_name = state.theme_name;
    return <Settings_context.Provider value={state}>
      <Fragment>
        {children}
        {modals.all.map(id=>{
          const Cmp = modals[id].cmp;
          const on_close = ()=>{
            if (modals[id].props && modals[id].props.on_close_hdl)
            {
              const can_close = modals[id].props.on_close_hdl();
              if (can_close===false)
                return;
            }
            set_modals(old=>{
              const {[id]: current, ...rest} = old;
              perr({id: `www_hola_modal_${id}_hide`});
              return {...rest, [id]: {...current, opened: false}};
            });
            setTimeout(()=>{
              set_modals(old=>{
                const {[id]: current, ...rest} = old;
                console.log('remove modal', current);
                const all_arr = old.all.filter(_id=>_id!=id);
                return {...rest, all: all_arr};
              });
            }, 500);
          };
          return <Modal key={id} {...modals[id].props}
            is_open={modals[id].opened} portal on_close={on_close}
            cls={cn(state.theme.root, modals[id].props?.cls)}>
            <Cmp on_close={on_close}/>
          </Modal>;
        })}
        {popups_state.all.map(id=>{
          const Cmp = popups_state[id].cmp;
          return <Popup key={id} id={id} {...popups_state[id].props}
            is_open={popups_state[id].visible}>
            <Cmp />
          </Popup>;
        })}
      </Fragment>
    </Settings_context.Provider>;
};

interface i_use_theme_props {
    def?: t_theme_name;
    theme?: t_theme_name;
}
export const use_theme = (props: i_use_theme_props = {})=>{
    const {def, theme} = props;
    const ctx = useContext(Settings_context);
    const themes_add = ctx.themes_add;
    if (theme)
        return {...ctx, theme: themes_add[theme], theme_name: theme};
    const {theme_name} = ctx;
    if (theme_name=='default' && def)
        return {...ctx, theme: themes_add[def], theme_name: def};
    return ctx;
};

export const Callback_context = createContext({
    callbacks: {} as any,
});

export const Callback_provider = (props:any)=>{
    const state = useMemo(()=>{
        return {
            callbacks: {
                fn: props.fn,
            },
        };
    }, [props.fn]);
    return <Callback_context.Provider value={state}>
      {props.children}
    </Callback_context.Provider>;
};
